import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenCervicalCancerProceduresIndicatorC7Data } from "@/services/esus/indicator/esf/c7/getDetailedCitizensCervicalCancerProceduresIndicatorC7";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC7CitizenProceduresHistoryItem } from "./IndicatorEsfC7CitizenProceduresHistoryItem";
import { IndicatorEsfC7CitizenProceduresHistoryInfo } from "./IndicatorEsfC7CitizenProceduresHistoryInfo";

type IndicatorEsfC7CitizenProceduresHistoryProps = {
	citizenWithProcedures: DetailedCitizenCervicalCancerProceduresIndicatorC7Data;
};

export function IndicatorEsfC7CitizenProceduresHistory({
	citizenWithProcedures,
}: Readonly<IndicatorEsfC7CitizenProceduresHistoryProps>) {
	const indicatorEsfC7CitizenHistoryInfo = {
		fullName: citizenWithProcedures.fullName ? citizenWithProcedures.fullName : "N/A",
		birthdate: citizenWithProcedures.birthdate
			? dayjs(citizenWithProcedures.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithProcedures.birthdate ? getAge(citizenWithProcedures.birthdate) : "N/A",
		document: citizenWithProcedures.cpf
			? formatIdentifier(citizenWithProcedures.cpf)
			: citizenWithProcedures.cns ?? "",
		motherName: citizenWithProcedures.motherName ?? "",
		phone: citizenWithProcedures.phone ? phoneFormat(citizenWithProcedures.phone) : "",
		address:
			addressConcat(
				citizenWithProcedures.street,
				citizenWithProcedures.houseNumber,
				citizenWithProcedures.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC7CitizenProceduresHistoryInfo {...indicatorEsfC7CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(
					citizenWithProcedures.attendanceProcedureReqEvals ?? []
				).map<TimeLineContent>((attendance) => {
					return {
						content: (
							<IndicatorEsfC7CitizenProceduresHistoryItem
								attendanceProcedureReqEval={attendance}
							/>
						),
						eventDate: attendance.date
							? dayjs(attendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
